import { Button, Group } from "@mantine/core";
import { useState } from "react";
import ReactDOM from "react-dom";
import { useToast } from "../../../mantine/notifications/useToast";
import { useHistoricalDataImportState } from "../utils/useHistoricaDataImportState";
import { HistoricalDataImport } from "./HistoricalDataImport";

interface HistoricalDataImportWithStateAndControlsProps {
  buttonContainer?: HTMLElement;
  onSubmit: (startDate: string, endDate: string) => Promise<void>;
  onSkip: () => void;
}

function HistoricalDataImportWithStateAndControls({
  buttonContainer,
  onSubmit,
  onSkip
}: HistoricalDataImportWithStateAndControlsProps) {
  const [loading, setLoading] = useState(false);
  const [startDate, endDate, setDates] = useHistoricalDataImportState();
  const { showErrorToast } = useToast();

  function handleSubmit() {
    if (!startDate || !endDate) return;

    setLoading(true);
    onSubmit(startDate, endDate)
      .catch((e) => showErrorToast(e))
      .finally(() => setLoading(false));
  }

  function handleClickSkip() {
    onSkip();
  }

  const submitIsDisabled = !startDate || !endDate;

  return (
    <>
      <HistoricalDataImport onDatesChanged={setDates} />
      {buttonContainer && (
        <>
          {ReactDOM.createPortal(
            <Controls
              loading={loading}
              submitIsDisabled={submitIsDisabled}
              onClickImport={handleSubmit}
              onClickSkip={handleClickSkip}
            />,
            buttonContainer
          )}
        </>
      )}
    </>
  );
}

function Controls({
  loading,
  submitIsDisabled,
  onClickSkip,
  onClickImport
}: {
  loading: boolean;
  submitIsDisabled: boolean;
  onClickSkip: () => void;
  onClickImport: () => void;
}) {
  return (
    <Group gap="xs">
      <Button
        className="skip"
        color="primary"
        disabled={loading}
        onClick={onClickSkip}
      >
        Überspringen
      </Button>
      <Button
        color="secondary"
        disabled={submitIsDisabled}
        loading={loading}
        onClick={onClickImport}
      >
        Importieren
      </Button>
    </Group>
  );
}

export {
  HistoricalDataImportWithStateAndControls,
  HistoricalDataImportWithStateAndControlsProps
};
